export default __webpack_public_path__ + "static/media/default_photo.5efa95be.svg";